// ==============READ/GET EMPLOYEES ================
export const EMPLOYEES_PUT = 'EMPLOYEES_PUT'

//@TODO fetchhing to false?
export function employeesPut(employees){
    return{
        type: EMPLOYEES_PUT,
        isFetching: true,
        employees: employees
    }
}

export const EMPLOYEES_PROFILE_IMG_SET = 'EMPLOYEES_PROFILE_IMG_SET';
export const EMPLOYEES_PROFILE_IMG_SET_UPLOAD= 'EMPLOYEES_PROFILE_IMG_SET_UPLOAD';
export const EMPLOYEES_PROFILE_IMG_SET_SUCCESS = 'EMPLOYEES_PROFILE_IMG_SET_SUCCESS';
export const EMPLOYEES_PROFILE_IMG_SET_FAILURE = 'EMPLOYEES_PROFILE_IMG_SET_FAILURE';
export const EMPLOYEES_PROFILE_IMG_DELETE = 'EMPLOYEES_PROFILE_IMG_DELETE';
export const EMPLOYEE_SET_NAME = 'EMPLOYEE_SET_NAME';
export const EMPLOYEE_SET_DISPLAY_NAME = 'EMPLOYEE_SET_DISPLAY_NAME';
export const EMPLOYEE_SET_LOADING = 'EMPLOYEE_SET_LOADING';
export const EMPLOYEE_SET_DONE = 'EMPLOYEE_SET_DONE';

export function setEmployeeName(id, name){
    return{
        type: EMPLOYEE_SET_NAME,
        id: id,
        name: name
    }
}

export function setEmployeeDisplayName(id, displayName){
    return{
        type: EMPLOYEE_SET_DISPLAY_NAME,
        id: id,
        displayName: displayName
    }
}

export function setLoading(){
    return{
        type: EMPLOYEE_SET_LOADING,
        isUploading: true
    }
}

export function setDone(){
    return{
        type: EMPLOYEE_SET_DONE,
        isUploading: false
    }
}

export function deleteEmployeesProfileImg(id){
    return{
        type: EMPLOYEES_PROFILE_IMG_DELETE,
        id: id
    }
}

export function setEmployeesProfileImg(imgUrl, id){
    return{
        type: EMPLOYEES_PROFILE_IMG_SET,
        id: id,
        imgUrl: imgUrl,
    }
}

export function setEmployeesProfileImgUpload(){
    return{
        type: EMPLOYEES_PROFILE_IMG_SET_UPLOAD,
        isUploading: true
    }
}

export function setEmployeesProfileImgSuccess(){
    return{
        type: EMPLOYEES_PROFILE_IMG_SET_SUCCESS,
        isUploading: false
    }
}

export function setEmployeesProfileImgFailure(){
    return{
        type: EMPLOYEES_PROFILE_IMG_SET_FAILURE,
        isUploading: false
    }
}

export const EMPLOYEE_CREATE_REQUEST = 'employee create request'
export const EMPLOYEE_CREATE_SUCCESS = 'employee create success'
export const EMPLOYEE_CREATE_FAILURE = 'employee create failure'

export function employeeCreateRequest(){
    return{
        type: EMPLOYEE_CREATE_REQUEST,
        isFetching: true
    }

}
export function employeeCreateSuccess(employee){
    return{
        type: EMPLOYEE_CREATE_SUCCESS,
        isFetching: false,
        employee: employee
    }

}
export function employeeCreateFailure(){
    return{
        type: EMPLOYEE_CREATE_FAILURE,
        isFetching: false
    }

}

export const EMPLOYEE_DELETE_REQUEST = 'employee delete request'
export const EMPLOYEE_DELETE_SUCCESS = 'employee delete success'
export const EMPLOYEE_DELETE_FAILURE = 'employee delete failure'

export function employeeDeleteRequest(){
    return{
        type: EMPLOYEE_DELETE_REQUEST,
        isFetching: true
    }

}
export function employeeDeleteSuccess(employeeId){
    return{
        type: EMPLOYEE_DELETE_SUCCESS,
        id: employeeId,
        isFetching: false,
    }

}
export function employeeDeleteFailure(){
    return{
        type: EMPLOYEE_DELETE_FAILURE,
        isFetching: false
    }

}


export const EMPLOYEE_IS_ONLINE = 'employee is online'
export const EMPLOYEE_IS_OFFLINE = 'employee is offline'
export function employeeIsOnline(userId){
    return {
        type: EMPLOYEE_IS_ONLINE,
        id: userId,
        online: true
    }
}
export function employeeIsOffline(userId){
    return {
        type: EMPLOYEE_IS_OFFLINE,
        id: userId,
        online: false
    }
}



// WEBPACK FOOTER //
// ./src/model/Employee/actions.js